import React, { FC } from "react";
import { AccordionSummaryProps } from "@mui/material";

import { StyledMuiAccordionSummary } from "./styled";

export interface IStyledAccordionSummaryProps extends AccordionSummaryProps {}

export const StyledAccordionSummary: FC<IStyledAccordionSummaryProps> = props => {
  const { children, ...rest } = props;

  return <StyledMuiAccordionSummary {...rest}>{children}</StyledMuiAccordionSummary>;
};
